var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleXFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99999 0C4.02943 0 -7.23906e-06 4.02944 -7.23906e-06 9C-7.23906e-06 13.9706 4.02943 18 8.99999 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 8.99999 0ZM7.46996 6.09926C7.09146 5.72075 6.47777 5.72075 6.09927 6.09926C5.72076 6.47777 5.72076 7.09145 6.09927 7.46996L7.6293 9L6.09927 10.53C5.72076 10.9085 5.72076 11.5222 6.09927 11.9007C6.47777 12.2792 7.09146 12.2792 7.46996 11.9007L9 10.3707L10.53 11.9007C10.9085 12.2792 11.5222 12.2792 11.9007 11.9007C12.2792 11.5222 12.2792 10.9085 11.9007 10.53L10.3707 9L11.9007 7.46996C12.2792 7.09145 12.2792 6.47777 11.9007 6.09926C11.5222 5.72075 10.9085 5.72075 10.53 6.09926L9 7.6293L7.46996 6.09926Z",
    fill: "#B6072F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleXFilled);
export default __webpack_public_path__ + "static/media/circle-x-filled.a24dac32d1b525d5522264105009e7fe.svg";
export { ForwardRef as ReactComponent };